module.exports = __webpack_public_path__ + "static/media/微信 (2).af19a61d.svg";